/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_OwnerInputs */

const en_subscription_owner = /** @type {(inputs: Subscription_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Owner`)
};

const fr_subscription_owner = /** @type {(inputs: Subscription_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titulaire de l’abonnement`)
};

const de_subscription_owner = /** @type {(inputs: Subscription_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementinhaber`)
};

const it_subscription_owner = /** @type {(inputs: Subscription_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolare dell'abbonamento`)
};

const ru_subscription_owner = /** @type {(inputs: Subscription_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Владелец подписки`)
};

const es_subscription_owner = /** @type {(inputs: Subscription_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propietario de la suscripción`)
};

const zh_cn2_subscription_owner = /** @type {(inputs: Subscription_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅所有者`)
};

const ja_subscription_owner = /** @type {(inputs: Subscription_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプション所有者`)
};

const hi_subscription_owner = /** @type {(inputs: Subscription_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता स्वामी`)
};

const pt_pt2_subscription_owner = /** @type {(inputs: Subscription_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietário da assinatura`)
};

/**
* | output |
* | --- |
* | "Subscription Owner" |
*
* @param {Subscription_OwnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_owner = /** @type {((inputs?: Subscription_OwnerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_OwnerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subscription_owner(inputs)
	if (locale === "de") return de_subscription_owner(inputs)
	if (locale === "it") return it_subscription_owner(inputs)
	if (locale === "ru") return ru_subscription_owner(inputs)
	if (locale === "es") return es_subscription_owner(inputs)
	if (locale === "zh-CN") return zh_cn2_subscription_owner(inputs)
	if (locale === "ja") return ja_subscription_owner(inputs)
	if (locale === "hi") return hi_subscription_owner(inputs)
	if (locale === "pt-PT") return pt_pt2_subscription_owner(inputs)
	return en_subscription_owner(inputs)
});